import React from 'react';

interface PurchaseButtonProps {
  onClick: () => void;
  isLoading: boolean;
  label?: string;
  disabled?: boolean;
}

const PurchaseButton: React.FC<PurchaseButtonProps> = ({
  onClick,
  isLoading,
  label = 'Purchase',
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isLoading || disabled}
      className="purchase-controls__purchase-button"
    >
      {isLoading ? 'Purchasing...' : label}
    </button>
  );
};

export default PurchaseButton;
